const eventStatusTypes = {
  CREATED: "CREATED",
  SCHEDULED: "SCHEDULED",
  STARTING: "STARTING",
  STARTED: "STARTED",
  FINISHED: "FINISHED",
  ERROR: "ERROR",
  DELETED: "DELETED",
};

export const eventStatusTypesCopyable = [
  eventStatusTypes.SCHEDULED,
  eventStatusTypes.STARTING,
  eventStatusTypes.FINISHED,
  eventStatusTypes.ERROR,
  eventStatusTypes.DELETED,
];

export const isPastEvent = status => status && [eventStatusTypes.STARTED, eventStatusTypes.FINISHED].includes(status);

export const isErrorEvent = status => status && [eventStatusTypes.ERROR].includes(status);

export const isFutureEvent = status => status && !isErrorEvent(status) && !isPastEvent(status);

export const isDeletedEvent = status => status && [eventStatusTypes.DELETED].includes(status);

export default eventStatusTypes;
